import { api } from "@/lib/api"
import { sessionOfMyUser } from "@/utils/verifiedSession.utils"

export function useCurrentUser({
    shouldFetch = false,
}: { shouldFetch?: boolean } = {}) {
    const {
        data: user,
        isLoading,
        error,
        refetch,
    } = api.user.getMyUser.useQuery(undefined, {
        enabled: shouldFetch, // boolean-naming-exempt: external contract — tanstack query option
        refetchOnMount: shouldFetch ? "always" : false,
    })
    return { user, isLoading, error, refetch, session: sessionOfMyUser(user) }
}
